import {Controller} from "@/controllers/Controller";

/**
 * Controller for logistics API (ms-purchase) : stock, marchandises à réceptionner, affectation du stock aux dossiers
 */
export class LogisticsController extends Controller {

    // Ce qui est acheté et n'est affecté à aucun dossier
    static getStock() {
        return this.requestBuilder("GET", `/purchase/logistics/stock`, true);
    }

    // Achats de biens dont la livraison n'est pas complète
    static getToReceive() {
        return this.requestBuilder("GET", `/purchase/logistics/to-receive`, true);
    }

    // body : {purchaseId, lineId, orderId, quantity}
    static assign(body) {
        return this.requestBuilder("POST", `/purchase/logistics/assign`, true, body);
    }

    // Affecte des quantités d'articles du catalogue à un dossier, prélevées sur le stock de chaque article.
    // body : {orderId, items: [{articleId, quantity}]}
    static assignArticles(body) {
        return this.requestBuilder("POST", `/purchase/logistics/assign-articles`, true, body);
    }

    // Régularise les quantités affectées au-delà du stock avec les achats arrivés depuis. body : {articleId?}, tous les articles sinon.
    // Renvoie {regularizedQuantity, remainingQuantity}
    static regularize(body = {}) {
        return this.requestBuilder("POST", `/purchase/logistics/regularize`, true, body);
    }

    // Retire un article d'un dossier : ses quantités retournent en stock. body : {orderId, articleId}
    static unassignArticle(body) {
        return this.requestBuilder("POST", `/purchase/logistics/unassign-article`, true, body);
    }
}
